module.exports = __webpack_public_path__ + "img/Mask-Group-45.a62135ea.png";